import React from 'react';
import PropTypes from 'prop-types';
import CourseBatchDetails, { hasUnselectedBatch } from '../course-batch-details/CourseBatchDetails';

// Long inline SVG path data kept as constants so the JSX stays within max-len.
// eslint-disable-next-line max-len
const CALENDAR_ICON_PATH = 'M7.3335 11.6111C7.33344 12.3333 7.47566 13.0485 7.75204 13.7158C8.02841 14.3831 8.43353 14.9894 8.94426 15.5001C9.45499 16.0109 10.0613 16.416 10.7286 16.6924C11.396 16.9688 12.1112 17.1111 12.8335 17.1111C13.5558 17.1111 14.271 16.9688 14.9384 16.6924C15.6057 16.416 16.212 16.0109 16.7227 15.5001C17.2335 14.9894 17.6386 14.3831 17.915 13.7158C18.1913 13.0485 18.3336 12.3333 18.3335 11.6111C18.3336 10.8888 18.1913 10.1736 17.915 9.50636C17.6386 8.83907 17.2335 8.23275 16.7227 7.72202C16.212 7.21129 15.6057 6.80616 14.9384 6.52976C14.271 6.25335 13.5558 6.11108 12.8335 6.11108C12.1112 6.11108 11.396 6.25335 10.7286 6.52976C10.0613 6.80616 9.45499 7.21129 8.94426 7.72202C8.43353 8.23275 8.02841 8.83907 7.75204 9.50636C7.47566 10.1736 7.33344 10.8888 7.3335 11.6111Z';
// eslint-disable-next-line max-len
const CLOCK_ICON_PATH = 'M7.78027 11.4785C7.78022 12.1197 7.9065 12.7547 8.15188 13.3472C8.39727 13.9397 8.75696 14.478 9.21042 14.9315C9.66388 15.3849 10.2022 15.7446 10.7947 15.99C11.3872 16.2354 12.0222 16.3618 12.6635 16.3618C13.3049 16.3618 13.9399 16.2354 14.5324 15.99C15.1249 15.7446 15.6632 15.3849 16.1167 14.9315C16.5701 14.478 16.9298 13.9397 17.1752 13.3472C17.4206 12.7547 17.5469 12.1197 17.5468 11.4785C17.5469 10.8372 17.4206 10.2022 17.1752 9.60977C16.9298 9.0173 16.5701 8.47897 16.1167 8.02551C15.6632 7.57206 15.1249 7.21235 14.5324 6.96694C13.9399 6.72153 13.3049 6.59521 12.6635 6.59521C12.0222 6.59521 11.3872 6.72153 10.7947 6.96694C10.2022 7.21235 9.66388 7.57206 9.21042 8.02551C8.75696 8.47897 8.39727 9.0173 8.15188 9.60977C7.9065 10.2022 7.78022 10.8372 7.78027 11.4785Z';

function MinDetailsHeader({
  skuName,
  batchDetail,
  orderMessage,
  orderId,
  orderCreatedAt,
  courseType,
  showMessage = true,
  hasTestPapers = false,
  brand,
  promotionalEventName,
  transferMeta,
  orderItems,
}) {
  // The default message offers a choice that only exists while some course in the
  // order is actually still without a batch — once every batch is set there is
  // nothing left to pick, and the message just sits there contradicting the batch
  // details right above it. A transfer order already has its target batch chosen as
  // part of the transfer itself, so it never applies there either.
  const canChooseBatchLater = !hasTestPapers && !transferMeta && hasUnselectedBatch(orderItems);
  const defaultOrderMessage = canChooseBatchLater
    ? 'For courses without a selected batch, you can choose your preferred batch after purchase.'
    : '';
  const orderMessageTemp = orderMessage || defaultOrderMessage;
  const examDetail = batchDetail;
  const formatedDate = new Date(Number(orderCreatedAt)).toLocaleString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  return (
    <div className="flex pt-8 relative flex-col items-center mb-8">

      <div
        className="border relative border-[1px] border-[#B8E5FF] w-[90%] lg:w-4/5 rounded-[6px] px-[9px] py-3 bg-white"
      >
        {courseType && (
        <h1
          className="w-fit right-1 top-1 bg-[#E3EAFF] rounded absolute text-[12px] text-md py-1 px-1 text-[#002FFF]"
        >
          {courseType}
        </h1>
        )}
        <div className="flex flex-col items-start p-1 ">
          {examDetail && (
            <div className="w-full">
              <h1 className="w-fit bg-[#E9F3FF] rounded  text-[12px] text-md py-1 px-1 text-[#217ABB]">
                For
                {' '}
                {examDetail}
              </h1>
            </div>
          )}
          <div className="flex flex-col mt-1 gap-1 item-center">
            <h1 className="text-xl font-semibold">
              {hasTestPapers && brand && promotionalEventName ? `${brand.toUpperCase()} : ${promotionalEventName}` : skuName}
            </h1>
          </div>
          {transferMeta?.productName && transferMeta?.transferTo?.productName && (
            <div className="flex items-center flex-wrap justify-center gap-2 mt-2 text-[12px] md:text-[13px]">
              <span className="px-2 py-0.5 rounded bg-[#FDEEEA] text-[#B91C1C] font-medium">
                {transferMeta.productName}
              </span>
              <span className="text-[#64748B]">&rarr;</span>
              <span className="px-2 py-0.5 rounded bg-[#E9F9EE] text-[#15803D] font-medium">
                {transferMeta.transferTo.productName}
              </span>
            </div>
          )}
          <CourseBatchDetails orderItems={orderItems} />
          {orderId && orderCreatedAt && (
            <div
              className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-8 mt-4 pt-3 border-t border-[#E2E8F0] w-full"
            >
              <div className="flex items-center gap-2 min-w-0">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 22 22"
                  fill="none"
                  className="flex-shrink-0"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d={CALENDAR_ICON_PATH}
                    fill="#B8E5FF"
                  />
                  <path
                    d="M15.8891 3.66675L6.11133 3.66675"
                    stroke="#0F0F0F"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16.8961 4.43652H18.4592C18.6781 4.43652 18.85 4.69508 18.85 5.02417V17.9523C18.85 18.2813 18.6781 18.5399 18.4592 18.5399H17.1852H13.4727H9.36945H5.65695H4.39079C4.17195 18.5399 4 18.2813 4 17.9523V5.02417C4 4.69508 4.17195 4.43652 4.39079 4.43652H5.95395"
                    stroke="#0F0F0F"
                    strokeWidth="0.8"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7.08301 4V9.72502"
                    stroke="#0F0F0F"
                    strokeWidth="0.8"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.7666 4V9.72502"
                    stroke="#0F0F0F"
                    strokeWidth="0.8"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.7666 9.7251L7.08239 9.7251"
                    stroke="#0F0F0F"
                    strokeWidth="0.8"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="flex flex-col leading-tight min-w-0">
                  <span className="text-[11px] text-[#64748B]">Order ID</span>
                  <span
                    className="text-[13px] font-semibold text-[#334155] break-all"
                  >
                    {orderId}
                  </span>
                </div>
              </div>
              <div className="hidden sm:block h-8 w-px bg-[#E2E8F0]" />
              <div className="flex items-center gap-2">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 22 22"
                  fill="none"
                  className="flex-shrink-0"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d={CLOCK_ICON_PATH}
                    fill="#B8E5FF"
                  />
                  <path
                    d="M13.3798 4.83862H8.69189"
                    stroke="#0F0F0F"
                    strokeWidth="0.8"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16.5051 4.83862H18.0678C18.2865 4.83862 18.4584 5.08367 18.4584 5.39556V17.6481C18.4584 17.9599 18.2865 18.205 18.0678 18.205H16.7942H13.0829H8.98097H5.26969H4.00394C3.78517 18.205 3.61328 17.9599 3.61328 17.6481V5.39556C3.61328 5.08367 3.78517 4.83862 4.00394 4.83862H5.56659"
                    stroke="#0F0F0F"
                    strokeWidth="0.8"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M5.17578 7.96436H16.8956"
                    stroke="#0F0F0F"
                    strokeWidth="0.8"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.9424 3.66675V6.01072"
                    stroke="#0F0F0F"
                    strokeWidth="0.8"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7.12939 3.66675V6.01072"
                    stroke="#0F0F0F"
                    strokeWidth="0.8"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="flex flex-col leading-tight">
                  <span className="text-[11px] text-[#64748B]">Order Date</span>
                  <span
                    className="text-[13px] font-semibold text-[#334155] whitespace-nowrap"
                  >
                    {formatedDate}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {orderMessageTemp && showMessage && !hasTestPapers && (
        <div
          className="border relative border-[1px] border-[#B8E5FF] bg-[#DBF2FF70] w-[90%] lg:w-4/5 rounded-[6px] px-[9px] mt-4 py-3"
        >
          <h1 className="text-[14px] md:text-[16px]  ">
            <span className="font-semibold"> Info: </span>
            {orderMessageTemp}
          </h1>
        </div>
      )}
    </div>
  );
}

MinDetailsHeader.propTypes = {
  skuName: PropTypes.string.isRequired,
  orderMessage: PropTypes.string.isRequired,
  batchDetail: PropTypes.string,
  courseType: PropTypes.string,
  orderId: PropTypes.string,
  orderCreatedAt: PropTypes.string,
  showMessage: PropTypes.bool,
  hasTestPapers: PropTypes.bool,
  brand: PropTypes.string,
  promotionalEventName: PropTypes.string,
  transferMeta: PropTypes.shape({
    productName: PropTypes.string,
    transferTo: PropTypes.shape({
      productName: PropTypes.string,
    }),
  }),
  orderItems: PropTypes.array,
};
export default MinDetailsHeader;
